import { Sliders, UserPlus, Users,
    //  BarChart2,
    Grid,
 } from 'react-feather';

const pagesSection = [
  {
    href: '/user/dashboard',
    title: 'Dashboard',
    icon: Sliders,
    children: [
      {
        href: '/user/dashboard/default',
        title: 'Default',
      },
      {
        href: '/user/dashboard/ranking',
        title: 'Ranking',
      },
      {
        href: '/user/dashboard/user-statistics',
        title: 'User statistics',
      },
    ],
  },
  // Temporarily hidden until backend team completes their update
  // {
  //   href: 'statistik',
  //   title: 'Statistik',
  //   icon: BarChart2,
  //   children: [
  //     {
  //       href: '/user/statistik/hemsida',
  //       title: 'Hemsida',
  //     },
  //   ],
  // },
  {
    href: 'produkter',
    title: 'Produkter',
    icon: Grid,
    children: [
      {
        href: '/user/sites',
        title: 'Landningssidor',
      },
      {
        href: '/user/hemsidor',
        title: 'Hemsidor',
      },
    ],
  },
  {
    href: 'client',
    title: 'Inlogg kunder',
    icon: Users,
  },
  {
    href: 'kundföretag',
    title: 'Kundföretag',
    icon: Users,
  },
  {
    href: 'leads',
    title: 'Kundförfrågningar',
    icon: UserPlus,
  },
  {
    href: 'users',
    title: 'Användare',
    icon: Users,
  },
];

const navItems = [
  {
    title: '',
    pages: pagesSection,
  },
];

export default navItems;
